module.exports = __webpack_public_path__ + "img/priceBg.8c79b090.png";